<template>
    <v-main style="background-color: white;" id="printpage">
        <v-container color="white">
                    <v-list class="listol py-0"
                            v-for="p in recruitinglist">
                        <v-list-item class="my-0">
                            <v-list-item-avatar tile size="60">
                                <v-img :src="p.info.profilepic"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{p.info.firstname}} {{p.info.lastname}} GradYear {{p.info.gradyear}}   {{p.height?getHeight(p.height):''}}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{p.info.email?p.info.email+' ':''}}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    {{p.info.cell?p.info.cell+' | ':''}} {{p.info.instagram}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-avatar tile size="60" v-if="p.committed">
                                <v-img :src="p.committed.img"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-avatar tile size="80" v-else>
                                <v-img :src="'https://api.qrserver.com/v1/create-qr-code/?data=https://volleyforlife.com/recruiting/'+p.partkey+'&size=100x100'" />
                            </v-list-item-avatar>
                        </v-list-item>
                    </v-list>
            <div>
                <v-btn id="printbutton" @click="sendToPrint()" small outlined>Print</v-btn>
            </div>
        </v-container>
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "Recruitingsheet",
    components: {},
    data() {
      return {
        players: undefined
      }
    },
    computed: {
      ...mapState(['recruitinglist'])
    },
    mounted(){
      document.getElementById('printpage').onmousemove = function(){
        document.getElementById('printbutton').style.visibility = 'visible'
      }
    },
    methods: {
      ...mapActions(['get', 'post']),
      getHeight(n){
        let feet = parseInt(n/12)
        let inch = n%12
        return feet+'\' '+inch+'"'
      },
      sendToPrint(){
        //document.body.style.overflowX = 'hidden';
        document.getElementById('printbutton').style.visibility = 'hidden'
        window.print()
      },
    }
  }

</script>

<style scoped>

</style>